"use strict";

exports.__esModule = true;
exports.showCheck30 = exports.confirmOrder = exports.clickCheck30StartReading = void 0;

var _constants = require("../constants");

const eventLabel = (offer, type) => ({
  eventlabel: `subscriptionshop/confirmation?typeproduct=${offer}&typeflow=${type}`
});

const confirmOrder = (user, articleId, transactionId, transactionStatus, utms) => ({ ..._constants.eventBase,
  ..._constants.click,
  ..._constants.conversionWall,
  eventlabel: `confirm-order-${articleId}`,
  transactionid: `${transactionId}`,
  transactionstatus: transactionStatus,
  articleid: articleId,
  pageurl: window.location.href,
  utminternal: utms ? utms.utm_internal : null,
  utmartid: utms ? utms.utm_artid : null,
  utmprsid: utms ? utms.utm_prsid : null,
  utmcid: utms ? utms.utm_cid : null,
  ...(0, _constants.identityAccountId)(user)
});

exports.confirmOrder = confirmOrder;

const showCheck30 = (user, offer, type) => ({ ..._constants.eventBase,
  ...eventLabel(offer, type),
  ..._constants.conversionWall,
  ..._constants.show,
  ...(0, _constants.identityAccountId)(user)
});

exports.showCheck30 = showCheck30;

const clickCheck30StartReading = (user, offer, type) => ({ ..._constants.eventBase,
  ...eventLabel(offer, type),
  ..._constants.conversionWall,
  eventaction: `click-start-reading`,
  ...(0, _constants.identityAccountId)(user)
});

exports.clickCheck30StartReading = clickCheck30StartReading;